import * as React from 'react';

import styled from '@emotion/styled';
import isNil from 'lodash-es/isNil';

import { type CSSLengthUnit } from '~/utils/css';

const IconImg = styled.img<{ size?: string; verticalAlign?: string }>`
  width: ${({ size }) => (size ? size : '25px')};
  height: ${({ size }) => (size ? size : '25px')};
  vertical-align: ${({ verticalAlign }) => (isNil(verticalAlign) ? 'middle' : verticalAlign)};
`;

const Container = styled.div<{ size?: string }>`
  width: ${({ size }) => (size ? size : '25px')};
  position: relative;
`;

export type IconProps = {
  alt: string;
  children?: React.ReactNode;
  className?: string;
  imgVerticalAlign?: 'bottom' | 'middle' | 'top';
  // Accepts any CSS unit for width
  size?: CSSLengthUnit;
  src: string;
};

const Icon = ({ alt, children, className, imgVerticalAlign, size, src }: IconProps) => (
  <Container className={className} size={size}>
    <IconImg alt={alt} size={size} src={src} verticalAlign={imgVerticalAlign} />
    {children}
  </Container>
);

const ComposedIcon = React.memo(Icon);

export default ComposedIcon as React.ComponentType<IconProps>;
